module.exports = "/virtual-football/img/video/clubs/germany/hertha.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/germany/hertha.png
// module id = 296
// module chunks = 6